import { apiClient, getToken, getOrgId, getUserId } from '@devd-client/api';

export const addFavourite = (params: any): Promise<any> =>
  apiClient(`/v1/user/${getUserId()}/preference/metrics`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.data),
  });

export const updateAllFavourite = (params: any): Promise<any> =>
  apiClient(
    `/v1/user/${getUserId()}/preference/metrics?isUpdateAllFavouriteMetrics=true`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.data),
    }
  );

export const deleteFavourite = (params: any): Promise<any> => {
  return apiClient(
    `/v1/user/${getUserId()}/preference/metrics/${params.data.name}`,
    {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const deleteFavTeam = (params: any): Promise<any> => {
  return apiClient(
    `/v1/team/metric/org/${getOrgId()}/team/${params.team}/metric/${
      params.metric
    }`,
    {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postFavMetrics = (params: any) => {
  return apiClient(`/v1/team/metric/org/${getOrgId()}/team/${params.team}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params.metricsList),
  });
};
export const UpdateAllTeamFavMetrics = (params: any) => {
  return apiClient(
    `/v1/team/metric/org/${getOrgId()}/team/${
      params.team
    }?isUpdateAllFavouriteMetrics=true`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.metricsList),
    }
  );
};

export const fetchThresholdData = (metric: string, teamId: string) => {
  return apiClient(
    `/v1/threshold/org/${getOrgId()}/metric/${metric}${
      teamId !== '' && teamId !== 'Organisation' ? `?team=${teamId}` : ''
    }`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
    }
  );
};

export const postThresholdData = (params: any) => {
  return apiClient(
    `/v1/threshold/org/${getOrgId()}${
      params.teamId !== 'Organisation' ? `?team=${params.teamId}` : ''
    }`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `bearer ${getToken()}`,
      },
      body: JSON.stringify(params.body),
    }
  );
};

export const resetThresholdData = (metric: string) => {
  return apiClient(`/v1/threshold/metric/${metric}/default`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
};

export const getAllRepos = (): Promise<any> =>
  apiClient(`/v1/integration/git/org/${getOrgId()}/projects/lite?active=true`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
